import { render, staticRenderFns } from "./BuyersPremiumTaxRate.vue?vue&type=template&id=3b55b3f8&scoped=true"
import script from "./BuyersPremiumTaxRate.vue?vue&type=script&lang=js"
export * from "./BuyersPremiumTaxRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55b3f8",
  null
  
)

export default component.exports